import { render, staticRenderFns } from "./ShoppingPostCard.vue?vue&type=template&id=4c6301be&scoped=true&lang=pug&"
import script from "./ShoppingPostCard.vue?vue&type=script&lang=js&"
export * from "./ShoppingPostCard.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingPostCard.vue?vue&type=style&index=0&id=4c6301be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6301be",
  null
  
)

export default component.exports